import ReactGA from 'react-ga4'
import { TrackingEvents } from 'types/trackingEvent'

class Analytics {
  static trackEvent = (event: TrackingEvents): void => ReactGA.event(event)
}

export default Analytics
